
function getNewStateKey() {
  return new Date().getTime()
}

export {getNewStateKey}